export default __webpack_public_path__ + "static/media/error_wallet.95ba8b2f.png";